import { defineStore } from 'pinia'
import { ref, nextTick } from 'vue'

export const useDialogStore = defineStore('dialog', () => {
  // Confirmation dialog state
  const status = ref(false)
  const text = ref('')
  const callback = ref<(() => unknown) | null>(null)

  // Snackbar state
  const snackbar = ref(false)
  const snackbarText = ref('')
  const snackbarColor = ref('success')

  // Actions
  function ask(options: { text: string; callback: () => unknown }) {
    status.value = true
    text.value = options.text
    callback.value = options.callback
  }

  function confirm() {
    if (callback.value) {
      callback.value()
    }
    close()
  }

  function close() {
    status.value = false
    text.value = ''
    callback.value = null
  }

  function popup(options: { text: string; color?: string }) {
    const showSnackbar = () => {
      snackbar.value = true
      snackbarText.value = options.text
      snackbarColor.value = options.color ?? 'success'
    }

    if (snackbar.value) {
      snackbar.value = false
      nextTick(showSnackbar)
    } else {
      showSnackbar()
    }
  }

  function setSnackbar(value: boolean) {
    snackbar.value = value
  }

  return {
    // State
    status,
    text,
    callback,
    snackbar,
    snackbarText,
    snackbarColor,
    // Actions
    ask,
    confirm,
    close,
    popup,
    setSnackbar,
  }
})
